export default "__VITE_ASSET__DeRUECcM__"